import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../api/apiService";
import { API_ENDPOINTS } from "../../../constants/apiEndpoints";

export const getDailyUsageAction = createAsyncThunk(
  "dailyUsage/getDailyUsage",
  async (_, thunkAPI) => {
    try {
      const response = await apiService.get(API_ENDPOINTS.DAILY_USAGE.GET);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const getDailyUsageByDateAction = createAsyncThunk(
  "dailyUsage/getDailyUsageByDate",
  async (date, thunkAPI) => {
    try {
      const response = await apiService.get(
        API_ENDPOINTS.DAILY_USAGE.GET_BY_DATE(date)
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const createDailyUsageAction = createAsyncThunk(
  "dailyUsage/createDailyUsage",
  async (usageData, thunkAPI) => {
    try {
      const response = await apiService.post(
        API_ENDPOINTS.DAILY_USAGE.CREATE,
        usageData
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const updateDailyUsageAction = createAsyncThunk(
  "dailyUsage/updateDailyUsage",
  async ({ usageId, usageData }, thunkAPI) => {
    try {
      const response = await apiService.put(
        API_ENDPOINTS.DAILY_USAGE.UPDATE(usageId),
        usageData
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
